<template>
  <vx-card>
    <div class="vx-row items-center p-3">
      <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
        <div>
          <div>
            <span class="header-plan">{{ $t("setup.label.PlanName") }}- </span>
            <span class="header-text" v-if="planName">
              {{ planName }}
            </span>
          </div>
        </div>
      </div>
      <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
        <div class="version-container">
          <div class="tag">
            {{ mode === "edit" ? "DRAFT" : planStatus }}
          </div>
          <div class="tag" v-if="planVersion > 0">
            {{ $t("setup.label.Version") }} :
            {{
              planStatus === "ACTIVE" && mode === "edit"
                ? planVersion + 1
                : planVersion
            }}
          </div>
          <div
            class="tag-approval"
            v-if="planStatus === 'DRAFT' && mode != 'view'"
            @click="makerCheckerApproval()"
          >
            {{ $t("setup.label.requestApproval") }}
          </div>
        </div>
      </div>
    </div>
    <div class="dual-listbox-wrapper">
      <!-- Source Discounts -->
      <div class="listbox">
        <div class="listbox-header">
          <h6 class="text-left font-bold">
            {{ $t("setup.label.AvailableDiscounts") }}
          </h6>
          <input
            v-show="mode !== 'view'"
            v-model="searchSource"
            :placeholder="$t('setup.label.Search')"
            class="border search-box rounded p-2 w-1/2"
          />
        </div>
        <ul class="listbox-body">
          <li
            v-for="discount in filteredSourceDiscounts"
            :key="discount.id"
            :class="[
              'listbox-item',
              selectedSourceDiscount === discount.id ? 'active' : '',
            ]"
            @click="onClickSourceDiscount(discount.id)"
          >
            <vx-tooltip
              :text="discount.name"
              color="primary"
              position="topLeft"
            >
              <span>
                {{ discount.code }}
              </span>
            </vx-tooltip>
          </li>
        </ul>
      </div>

      <!-- Arrows -->
      <div class="arrow-buttons">
        <button
          class="arrow-button"
          :disabled="!selectedSourceDiscount || mode == 'view'"
          @click="moveToTarget"
        >
          <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
        </button>
        <button
          class="arrow-button"
          :disabled="!selectedTargetDiscount || mode == 'view'"
          @click="moveToSource"
        >
          <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
        </button>
      </div>

      <!-- Target Discounts -->
      <div class="listbox">
        <div class="listbox-header">
          <h6 class="text-left font-bold">
            {{ $t("setup.label.SelectedDiscounts") }}
          </h6>
          <input
            v-show="mode !== 'view'"
            v-model="searchTarget"
            :placeholder="$t('setup.label.Search')"
            class="border search-box rounded p-2 w-1/2"
          />
        </div>
        <ul class="listbox-body">
          <li
            v-for="discount in filteredTargetDiscounts"
            :key="discount.id"
            :class="[
              'listbox-item',
              selectedTargetDiscount === discount.id ? 'active' : '',
            ]"
            @click="onClickTargetDiscount(discount.id)"
          >
            <vx-tooltip
              :text="discount.name"
              color="primary"
              position="topLeft"
            >
              <span>
                {{ discount.code }}
              </span>
            </vx-tooltip>
          </li>
        </ul>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="vx-row mb-10" style="display: flex; justify-content: center">
      <span class="ml-1 mr-2">
        <vs-button
          v-if="routeId"
          class="footerButton-next"
          v-show="mode != 'view'"
          icon-pack="feather"
          @click.prevent="editDiscountMapping"
        >
          {{ $t("setup.label.SaveAndContinue") }}
        </vs-button>
        <vs-button
          v-else
          class="footerButton-next"
          icon-pack="feather"
          v-show="mode != 'view'"
          @click.prevent="createDiscountMapping"
        >
          {{ $t("setup.label.SaveAndContinue") }}
        </vs-button>
      </span>
    </div>
  </vx-card>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      planDiscountMapPopup: false,
      selectedSourceDiscount: null,
      selectedTargetDiscount: null,
      selectedDiscountPlan: {},
      discounts: [],
      discountInit: {},
      searchSource: "",
      searchTarget: "",
    };
  },
  props: {
    planId: Number,
    routeId: Number,
    planName: String,
    planVersion: Number,
    planStatus: String,
    mode: String,
  },
  computed: {
    ...mapState({
      planDiscountData: (state) => state.planPrice.planDiscountData,
    }),
    filteredSourceDiscounts() {
      if (this.discountInit && this.discountInit.sourceDiscounts) {
        return this.discountInit.sourceDiscounts.filter(
          (d) =>
            d.name.toLowerCase().includes(this.searchSource.toLowerCase()) &&
            d.offerType == "Discount"
        );
      } else {
        return null;
      }
    },
    filteredTargetDiscounts() {
      if (this.discountInit && this.discountInit.targetDiscounts) {
        return this.discountInit.targetDiscounts.filter((d) =>
          d.name.toLowerCase().includes(this.searchTarget.toLowerCase())
        );
      } else {
        return null;
      }
    },
  },
  components: {
    AtomSpinner,
  },
  // planDiscountData
  methods: {
    moveToTarget() {
      if (!this.selectedSourceDiscount) return;

      const selectedDiscount = this.discountInit.sourceDiscounts.find(
        (discount) => discount.id === this.selectedSourceDiscount
      );

      if (selectedDiscount) {
        // Move to target list
        this.discountInit.targetDiscounts.push(selectedDiscount);
        // Remove from source list
        this.discountInit.sourceDiscounts =
          this.discountInit.sourceDiscounts.filter(
            (discount) => discount.id !== this.selectedSourceDiscount
          );
        // Clear selection
        this.selectedSourceDiscount = null;
      }
    },

    moveToSource() {
      if (!this.selectedTargetDiscount) return;

      const selectedDiscount = this.discountInit.targetDiscounts.find(
        (discount) => discount.id === this.selectedTargetDiscount
      );

      if (selectedDiscount) {
        // Move back to source list
        this.discountInit.sourceDiscounts.push(selectedDiscount);
        // Remove from target list
        this.discountInit.targetDiscounts =
          this.discountInit.targetDiscounts.filter(
            (discount) => discount.id !== this.selectedTargetDiscount
          );
        // Clear selection
        this.selectedTargetDiscount = null;
      }
    },
    async initializeDiscounts() {
      if (this.planDiscountData && this.planDiscountData.length > 0) {
        let allDiscounts = [...this.discounts];

        let selectedDiscountIds = this.planDiscountData.map(
          (d) => d.discountId
        );

        let selectedDiscounts = allDiscounts.filter((d) =>
          selectedDiscountIds.includes(d.id)
        );

        let availableDiscounts = allDiscounts.filter(
          (d) => !selectedDiscountIds.includes(d.id)
        );

        this.$set(this, "discountInit", {
          sourceDiscounts: availableDiscounts,
          targetDiscounts: selectedDiscounts,
        });
      } else {
        this.$set(this, "discountInit", {
          sourceDiscounts: [...this.discounts],
          targetDiscounts: [],
        });
      }

      // Reset selected variables
      this.selectedSourceDiscount = null;
      this.selectedTargetDiscount = null;
    },
    async createDiscountMapping() {
      // Extract selected discount IDs and submit
      const selectedDiscountIds = this.discountInit.targetDiscounts.map(
        (discount) => discount.id
      );
      const payload = {
        planId: this.planId,
        discount: selectedDiscountIds,
      };
      try {
        await this.$store.dispatch(
          "planPrice/createPlanDiscountAction",
          payload
        );
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Discount Created Successfully!",
          type: "success",
        });
        this.$emit("completed");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async makerCheckerApproval() {
      try {
        this.$swal({
          title: "Do you want to send approval request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.sendApproval();
              this.$router.push(`/setup/plan-pricing`);
            } catch (error) {
              this.$toasted.error("something went wrong!!");
            }
          }
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async sendApproval() {
      try {
        await this.$store.dispatch("planPrice/sendApprovalAction", this.planId);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Approval request sent!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async editDiscountMapping() {
      const payload = {
        planId: this.planId,
        discount: this.discountInit.targetDiscounts.map((discount) => {
          const existingDiscount = this.planDiscountData.find(
            (d) => d.discountId === discount.id
          );

          if (existingDiscount) {
            return {
              id: existingDiscount.id,
              discountId: discount.id,
            };
          } else {
            return {
              discountId: discount.id,
            };
          }
        }),
      };

      try {
        await this.$store.dispatch(
          "planPrice/updatePlanDiscountAction",
          payload
        );
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Discount Updated Successfully!",
          type: "success",
        });
        this.$emit("completed");
      } catch (e) {
        //
      }
    },
    async getDiscountList() {
      this.loading = true;
      try {
        const res = await this.$store.dispatch("discount/fetchDiscountList");
        this.discounts = res.data.pageItems || [];
      } catch (e) {
        //
      }
      this.loading = false;
    },
    onClickSourceDiscount(id) {
      if (this.mode == "view") {
        return;
      } else {
        this.selectedSourceDiscount = id;
      }
    },
    onClickTargetDiscount(id) {
      if (this.mode == "view") {
        return;
      } else {
        this.selectedTargetDiscount = id;
      }
    },

    async viewPlanDiscountMethod(id) {
      try {
        const payload = id || this.planId;
        await this.$store.dispatch("planPrice/viewPlanDiscountAction", payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getDiscountList();
    if (this.routeId || this.planId) {
      await this.viewPlanDiscountMethod(this.routeId);
    }
    this.initializeDiscounts();
    this.loading = false;
  },
};
</script>
<style scoped lang="scss">
.rule-card {
  height: 300px;
  min-width: 250px;
  background-color: cornsilk;
  border: 1px solid #ede4e4;
}
.header-plan {
  margin-left: 2.5rem;
  font-weight: 500;
  font-size: large;
}
.header-text {
  margin-left: 1rem;
  font-weight: 500;
  font-size: medium;
}
.search-box {
  border: 1px solid #c4bfbf;
}
.tag-approval {
  border: 2px solid rgb(14, 140, 224);
  color: rgb(23, 180, 228);
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
